import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

import { App_Footer } from '../components/App_Footer_Retail';
import { App_Header } from '../components/App_Header_Retail';
import { ShowProductPicsModal } from './Modal_ShowProductPics'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';



 export function ViewProductDetailDataModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);
    
    let [productID, setProductID] = useState(props.data.productID);
    let [productSalePrice, setProductSalePrice] = useState(props.data.productSalePrice);
    let [productPublicPrice, setProductPublicPrice] = useState(props.data.productPublicPrice);
    let [productPicsModal, setProductPicsModal] = useState(false);
    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [showProductDetails, setShowProductDetails] = useState(false);

    let [productPic1, setProductPic1] = useState(null);
    let [productPic2, setProductPic2] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);

    let [productPic1_id, setProductPic1_id] = useState(null);
    let [productPic2_id, setProductPic2_id] = useState(null);
    let [productPic3_id, setProductPic3_id] = useState(null);
    let [productPic4_id, setProductPic4_id] = useState(null);

    let [selectedFile, setSelectedFile] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);



    // let createProductAddition_type = useRef(props.data.addition_type);
    // let createProductTypeRef = useRef(props.data.itemType);
    // let createProductDescriptionRef = useRef(props.data.itemDescription);
    // let createProductPartNumRef = useRef(props.data.vendorPartNum);
    // let createProductPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createProductAddressRef = useRef(props.data.vendorAddress);
    // let createProductCityRef = useRef(props.data.vendorCity);
    // let createProductCountryRef = useRef(props.data.vendorCountry);
    // let createProductCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createProductSalePriceRef = useRef(props.data.salePrice);
    // let createProductQtyInUse = useRef(props.data.qtyInUse);
    // let createProductDateCreated = useRef(props.data.dateCreated);
    // let createProductAddedBy = useRef(props.data.addedBy);


    let [createProductAddition_type, setCreateProductAddition_type] = useState(props.data.addition_type);

    let [productType, setProductType] = useState(null);
    let [productName, setProductName] = useState(null);
    let [productDescription, setProductDescription] = useState(null);
    let [productPartNum, setProductPartNum] = useState(null);
    let [productPhoneNumber, setProductPhoneNumber] = useState(null);
    let [productAddress, setProductAddress] = useState(null);
    let [productCity, setProductCity] = useState(null);
    let [productCountry, setProductCountry] = useState(null);
    let [productCostPerUnit, setProductCostPerUnit] = useState(null);
    //let [productSalePrice, setProductSalePrice] = useState(null);
    let [productQtyInUse, setProductQtyInUse] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productAddedBy, setProductAddedBy] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [quantityAvailable, setQuantityAvailable] = useState(null);
    let [quantityUnits, setQuantityUnits] = useState(null);


function getProductDetailData() {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74308_retail',
            user: acctID,
            xInventoryProductID: props.data.productID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

            let cols = rows[0].split('|');

            setProductID(cols[0]);
            setProductType(cols[1]);
            setProductName(cols[2]);
            setProductDescription(cols[3]);
            setProductPartNum(cols[4]);
            setProductPhoneNumber(cols[5]);
            setProductAddress(cols[6]);
            setProductCity(cols[7]);
            setProductCountry(cols[8]);
            setProductCostPerUnit(parseFloat(cols[9]).toFixed(2));
            setProductSalePrice(parseFloat(cols[10]).toFixed(2));
            
            setProductPic1_id(cols[11]);            
            setProductPic1(cols[12]);
            
            setProductPic2_id(cols[13]);
            setProductPic2(cols[14]);
                        
            setProductPic3_id(cols[15]);
            setProductPic3(cols[16]);

            setProductPic4_id(cols[17]);
            setProductPic4(cols[18]);

            setAttachment(cols[19]);
            setQuantityAvailable(cols[20]);
            setQuantityUnits(cols[21]);
            setProductPublicPrice(cols[22]);

            // setViewProductDetailsData((prevViewProductDetailsData) => {
            //     return prevViewProductDetailsData.concat({
            //         productID: cols[0],
            //         productType: cols[1],
            //         productName: cols[2],
            //         productDescription: cols[3],
            //         productPartNum: cols[4],
            //         productPhoneNumber: cols[5],
            //         productAddress: cols[6],
            //         productCity: cols[7],
            //         productCountry: cols[8],
            //         productCostPerUnit: parseFloat(cols[9]).toFixed(2),
            //         productSalePrice: parseFloat(cols[10]).toFixed(2),
            //         productPic1: cols[11],
            //         productPic2: cols[12],
            //         productPic3: cols[13],
            //         productPic4: cols[14],
            //         attachment: cols[15],
            //         quantityAvailable: cols[16],
            //         qtyUnits: cols[17],


            //     })
            // });

        
    })

}

function updateProduct() {

    let formData = new FormData();
    //formData.append('xProductPics', totalProductPics);
    //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
    formData.append('Tracker', '74300_update_product');
    formData.append('user', acctID);
    formData.append('merchantSchema', schema);
    formData.append('xInventoryProductID', props.data.productID);
    //formData.append('xInventoryItemID', itemID);
    formData.append('xInventoryProductType', productType);
    formData.append('xInventoryProductName', productName);
    formData.append('xInventoryProductDescription', productDescription);
    formData.append('xInventoryProductPartNum', productPartNum);
    formData.append('xInventoryProductPhoneNumber', productPhoneNumber);
    formData.append('xInventoryProductAddress', productAddress);
    formData.append('xInventoryProductCity', productCity);
    formData.append('xInventoryProductCountry', productCountry);
    formData.append('xInventoryProductCostPerUnit', productCostPerUnit);
    formData.append('xInventoryProductSalePrice', productSalePrice);
    formData.append('xInventoryProductPublicPrice', productPublicPrice);
    formData.append('xProductQuantityAvailable', quantityAvailable);
    formData.append('xProductQtyUnits', quantityUnits);
    //formData.append('xSupportingDocumentation', selectedFile);
    //formData.append('xEnterAdminPassword', adminPassword);
    //formData.append('xStorefront', props.data.storefront);
    formData.append('sessionID', sessionID);
    // formData.append('xPic1', productPic1);
    // formData.append('xPic2', productPic2);
    // formData.append('xPic3', productPic3);
    // formData.append('xPic4', productPic4);


    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        //credentials: 'include',
        file: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    


    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(data => {

        alert(data);

        getProductDetailData(); 

    })
    .catch(error => {
        console.error(error);
    })

}

function handleCreateProductSalePrice(event) {
    const salePrice = parseFloat(event) || 0; // convert to number, default 0
    setProductSalePrice(salePrice);

    const productPublicPrice = salePrice + (salePrice * 0.03);
    setProductPublicPrice(productPublicPrice);
}

function closeModalHandler() {

    props.closeModal(false);
}

useEffect(() =>  {

    //alert("In produt detals modal");
    //alert(props.data.productID);

        
    getProductDetailData(); 

}, [])

            return(

                <React.Fragment>
                {props.openModal == true ?
                (
            <IonModal id='showProductDetails' isOpen={ props.openModal}>

                <IonHeader style={{color: "black"}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonText>PRODUCT DETAILS</IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='6'>Product ID</IonCol>
                                <IonCol size='6'>Sale Price</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'><IonText>{productID}</IonText></IonCol>
                                <IonCol size='6'><IonText>{productSalePrice}</IonText></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='grid_content'>
                        <IonGrid >
                            {/*<IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Type: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonInput className='professional-input'
                                    value={productType}
                                    placeholder="Enter Product Type"
                                    onIonChange={(e) => setProductType(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>*/}  
                            <IonRow class='gridResultBody'>
                                <IonCol size='6' class='gridResultHeaders'>Product Images</IonCol>
                                <IonCol size='6' class='gridResultColumns'>
                                    <ShowProductPicsModal openModal={ productPicsModal } closeModal={() => setProductPicsModal(false)} data={{
                                    productPic1_id: productPic1_id, 
                                    productPic2_id: productPic2_id, 
                                    productPic3_id: productPic3_id, 
                                    productPic4_id: productPic4_id,
                                    productPic1: productPic1, 
                                    productPic2: productPic2, 
                                    productPic3: productPic3, 
                                    productPic4: productPic4, 
                                    productID: productID, 
                                    productSalePrice: productSalePrice
                                    }}></ShowProductPicsModal>
                                    <IonButton class='gridResultColumnButton' onClick={() => setProductPicsModal(true)}> View </IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Name: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productName}
                                    placeholder="Enter Product Name"
                                    onIonChange={(e) => setProductName(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Description: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productDescription}
                                    placeholder="Enter Product Description"
                                    onIonChange={(e) => setProductDescription(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            {/*<IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Part Number: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productPartNum}
                                    placeholder="Enter Product Part Number"
                                    onIonChange={(e) => setProductPartNum(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Phone Number: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productPhoneNumber}
                                    placeholder="Enter Product Phone Number"
                                    onIonChange={(e) => setProductPhoneNumber(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Address: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productAddress}
                                    placeholder="Enter Product Address"
                                    onIonChange={(e) => setProductAddress(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>*/}  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product City: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productCity}
                                    placeholder="Enter Product City"
                                    onIonChange={(e) => setProductCity(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Country: </IonLabel>
                                    <select className='professional-input' name="country" id='country' value={productCountry} onChange={(e) => setProductCountry(e.target.value)}>
                                        <option value='GHANA' selected>Ghana</option>
                                        <option value='USA'>USA</option>
                                        <option value='CHINA'>CHINA</option>
                                    </select>
                                </IonCol>
                            </IonRow>  
                            {/*<IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Product Cost Per Unit: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productCostPerUnit}
                                    placeholder="Enter Product Cost Per Unit"
                                    onIonChange={(e) => setProductCostPerUnit(e.target.value)}
                                    ></IonInput>
                                    <IonText className='professional-input'>{productPublicPrice}</IonText>
                                </IonCol>
                            </IonRow>*/}  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Merchant Price: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={productSalePrice}
                                    type='number' 
                                    step='any'
                                    placeholder="Enter Merchant Price"
                                    onIonChange={(e) => handleCreateProductSalePrice(e.target.value)}
                                    required
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked" >Customer Price:</IonLabel>
                                    <IonText className='professional-input'>{productPublicPrice}</IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='6'>
                                    <IonLabel className="form-label" position="stacked"> Quantity Available: </IonLabel>
                                    <IonText className='professional-input'>{quantityAvailable}</IonText>
                                    {/*<IonInput className='professional-input'
                                    value={quantityAvailable}
                                    placeholder="Enter Quantity Available"
                                    onIonChange={(e) => setQuantityAvailable(e.target.value)}
                                    ></IonInput>*/}
                                </IonCol>
                                <IonCol size='6'>
                                    <IonLabel className="form-label" position="stacked"> Qty Units: </IonLabel>
                                    <select className='professional-input' name="qtyUnitsRef" id='qtyUnitsRef' value={quantityUnits} onChange={(e) => setQuantityUnits(e.target.value)}>
                                        <option value='ea' selected>Quantity</option>
                                        <option value='g'>grams</option>
                                        <option value='kg'>Kilograms</option>
                                        <option value='L'>Liters</option>
                                    </select>
                                </IonCol>
                            </IonRow>  
                            </IonGrid>
                        </IonContent>
                        <IonFooter class='grid_footer'>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size="6">
                                            <IonButton onClick={() => updateProduct()}> Save </IonButton>
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonButton  onClick={() => closeModalHandler()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonFooter>
                    </IonModal>) : null}
    </React.Fragment>
            )
}   



export default ViewProductDetailDataModal;